/*
 * @Author: shjy
 * @Date: 2025-04-15 14:41:41
 * @LastEditors: shijy
 * @LastEditTime: 2025-04-16 11:00:27
 * @Description:
 *
 * Copyright (c) 2025 by 重庆大学音像出版社有限公司, All Rights Reserved.
 */
import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'
import {getCache, saveCache} from '@/utils/localStorage'
export const useAuthStore = defineStore('auth', {
  state: () => {
    let  dpAuth = getCache('dpAuth')
    let token = ''
    if (false != dpAuth) {
        token =  dpAuth.token
    }
    return {token: token}
 },
  actions: {
    setToken(newToken) {
      this.token = newToken
      saveCache('dpAuth',{token:newToken})
    },
    clearToken() {
      this.token = ''
    }
  },
  getters: {
    authorizationHeader: (state) => state.token ? { Authorization: `Bearer ${state.token}` } : {}
  }
})